'use client';
import {Tabs as RACTabs, TabsProps} from 'react-aria-components';
import './Tabs.css';

export function Tabs(props: TabsProps) {
  return <RACTabs {...props} />;
}
